import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeModal } from '../tutor_assignment/tutorAssignmentSlice/tutorAssignmentSlice'
import './index.scss'
import CloseIcon from "react-icons/lib/md/close";
import { useTranslation } from 'react-i18next';
import StudentList from './components/StudentList';
import StoriesList from './components/StoriesList';
import Loading from '../../components/Global/Loading';

export default function TutorAssignmentModal() {
  const dispatch = useDispatch()
  const {t} = useTranslation("tutor_assignment_modal")
  const isModalOpen = useSelector((state) => state.tutorAssignment.isModalOpen)
  const assignments = useSelector((state) => state.tutorAssignment.assignments);
  const roster = useSelector((state) => state.reports.roster);
  const assignStoryLoading = useSelector((state) => state.tutorAssignment.isLoading);

  const loadingState =  assignStoryLoading || !roster?.data?.student?.length || !assignments?.length;

  if (!isModalOpen) return null;

  return (
    <div className="tutor-assignment-modal">
      <div className="tutor-assignment-modal__content">
      <h2 className='tutor-assignment-modal__title'>{t("add_an_assignment")}</h2>
        <CloseIcon className="tutor-assignment-modal__close-button" onClick={() => dispatch(closeModal())} />
        <div className='tutor-assignment-modal__body'>
          {loadingState ? <Loading /> : (
            <>
              <StudentList assignments={assignments} roster={roster} />
              <StoriesList assignments={assignments} roster={roster} />
            </>
          )}
          </div>
      </div>
    </div>
  )
}